import {
  DisbursementBatchCounts,
  DisbursementBatchTotals
} from '@percent/admin-dashboard/api/actions/disbursements/disbursements.types'

export type DisbursementStatusAndTotal =
  | 'total'
  | 'approvalRequired'
  | 'trusteeApprovalRequired'
  | 'agentApprovalRequired'
  | 'managerApprovalRequired'
  | 'approved'
  | 'inTransit'
  | 'paid'
  | 'cancelled'
  | 'returned'
  | 'failed'

// Columns rendered in the status overview, in display order.
export const STATUS_OVERVIEW_STATUSES = [
  'total',
  'trusteeApprovalRequired',
  'agentApprovalRequired',
  'managerApprovalRequired',
  'inTransit',
  'paid',
  'returned',
  'failed',
  'cancelled'
] as const

export type StatusOverviewStatus = typeof STATUS_OVERVIEW_STATUSES[number]

export type DisbursementSummaryRow = {
  status: DisbursementStatusAndTotal
  count: number
}

export type StatusOverviewProps = {
  counts: DisbursementBatchCounts
  totals: DisbursementBatchTotals
  showReturned: boolean
}
